import { render, staticRenderFns } from "./DocumentTab.vue?vue&type=template&id=4058dc25&scoped=true&"
import script from "./DocumentTab.vue?vue&type=script&lang=ts&"
export * from "./DocumentTab.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentTab.vue?vue&type=style&index=0&id=4058dc25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4058dc25",
  null
  
)

export default component.exports